import { Fragment } from 'react';

import { LevelProps } from '../../../Level';
import { NekuodahProps } from '../../../types/NekuodahProps';

export const getLevels = (
  components: NekuodahProps['components'],
  children: NekuodahProps['children'],
): LevelProps => {
  const reversedLevels = components.slice().reverse();

  return reversedLevels.reduce(
    (acc: LevelProps, provider: React.ElementType) => ({
      component: provider,
      childComponent: acc,
    }),
    {
      component: Fragment,
      children,
    } as LevelProps,
  );
};
